// Auto-focuses the element when inserted into the DOM
export function focus(node: HTMLElement) {
  Promise.resolve().then(() => node.focus());
}
